// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Tree */
.file-manager__body-tree {
	order: 0;
	border-right: 1px solid #dee2e6;
	overflow: auto;
	flex-grow: 0;
	flex-shrink: 0;
	box-sizing: border-box;
	transition: flex-basis 0.3s ease, border 0.3s ease;
}

.file-manager__body-tree.collapsed {
	flex-basis: 0;
	border: none;
}

.parent-container {
	padding-left: 14px;
	position: relative;
	padding: 0;
}

.child-parent-container {
	left: 0;
	width: 100%;
}


.file-manager__body-tree li {
	list-style: none;
	padding-left: 8px;
	cursor: pointer;
}
.file-manager__body-tree li li {
	padding-left: 30px;
}
.file-manager__body-tree li li.parent-node {
	padding-left: 16px;
}
.file-manager__body-tree li > div {
	display: flex;
	justify-content: flex-start;
	align-items: center;
	padding: 5px;
}
.file-manager__body-tree li ul {
	padding: 0;
}

.li-text-content {
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;

	pointer-events: none;

	-webkit-user-select: none;

	        user-select: none;
	cursor: pointer;
	margin: 0;
	padding: 0 0 0 10px;
	z-index: 1;
}

.file-manager__body-tree .expand {
	z-index: 1;
	display: flex;
	justify-content: center;
	align-items: center;
	font-size: 14px;
}

.li-text-content em {
   font-size: 20px;
   color: #FDDD34;
   position: relative;
}

.li-text-content span {
	margin-left: 2px;
}


.file-manager__body-tree li > div:hover {
	background-color: #e9ecef;
	border-color: #e9ecef;
	color: #333;
	border-radius: 4px;
}

.file-manager__body-tree li.active > div {
	background-color: #0d6efd;
	color: #fff;
	text-overflow: ellipsis;
	white-space: nowrap;
	font-weight: 400;
	opacity: 1;
	width: 100%;
	border-radius: 4px;
}

.file-manager__body-tree li.active > div > .li-text-content,
.file-manager__body-tree li.active > div > .expand {
	color: #fff;
}

.file-manager__body-tree em.shared {
	position: absolute;
	bottom: 0;
	left: 2px;
	z-index: 1;
	color: #d2a055;
	font-size: 14px;
}

.file-browser > .table-container {
	overflow-y: visible;
}
`, "",{"version":3,"sources":["webpack://./app/src/js/components/filemanager/file-tree.css"],"names":[],"mappings":"AAAA,SAAS;AACT;CACC,QAAQ;CACR,+BAA+B;CAC/B,cAAc;CACd,YAAY;CACZ,cAAc;CACd,sBAAsB;CACtB,kDAAkD;AACnD;;AAEA;CACC,aAAa;CACb,YAAY;AACb;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,UAAU;AACX;;AAEA;CACC,OAAO;CACP,WAAW;AACZ;;;AAGA;CACC,gBAAgB;CAChB,iBAAiB;CACjB,eAAe;AAChB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,aAAa;CACb,2BAA2B;CAC3B,mBAAmB;CACnB,YAAY;AACb;AACA;CACC,UAAU;AACX;;AAEA;CACC,gBAAgB;CAChB,uBAAuB;CACvB,mBAAmB;;CAEnB,oBAAoB;;CAEpB,yBAAiB;;SAAjB,iBAAiB;CACjB,eAAe;CACf,SAAS;CACT,mBAAmB;CACnB,UAAU;AACX;;AAEA;CACC,UAAU;CACV,aAAa;CACb,uBAAuB;CACvB,mBAAmB;CACnB,eAAe;AAChB;;AAEA;GACG,eAAe;GACf,cAAc;GACd,kBAAkB;AACrB;;AAEA;CACC,gBAAgB;AACjB;;;AAGA;CACC,yBAAyB;CACzB,qBAAqB;CACrB,WAAW;CACX,kBAAkB;AACnB;;AAEA;CACC,yBAAyB;CACzB,WAAW;CACX,uBAAuB;CACvB,mBAAmB;CACnB,gBAAgB;CAChB,UAAU;CACV,WAAW;CACX,kBAAkB;AACnB;;AAEA;;CAEC,WAAW;AACZ;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,SAAS;CACT,UAAU;CACV,cAAc;CACd,eAAe;AAChB;;AAEA;CACC,mBAAmB;AACpB","sourcesContent":["/* Tree */\n.file-manager__body-tree {\n\torder: 0;\n\tborder-right: 1px solid #dee2e6;\n\toverflow: auto;\n\tflex-grow: 0;\n\tflex-shrink: 0;\n\tbox-sizing: border-box;\n\ttransition: flex-basis 0.3s ease, border 0.3s ease;\n}\n\n.file-manager__body-tree.collapsed {\n\tflex-basis: 0;\n\tborder: none;\n}\n\n.parent-container {\n\tpadding-left: 14px;\n\tposition: relative;\n\tpadding: 0;\n}\n\n.child-parent-container {\n\tleft: 0;\n\twidth: 100%;\n}\n\n\n.file-manager__body-tree li {\n\tlist-style: none;\n\tpadding-left: 8px;\n\tcursor: pointer;\n}\n.file-manager__body-tree li li {\n\tpadding-left: 30px;\n}\n.file-manager__body-tree li li.parent-node {\n\tpadding-left: 16px;\n}\n.file-manager__body-tree li > div {\n\tdisplay: flex;\n\tjustify-content: flex-start;\n\talign-items: center;\n\tpadding: 5px;\n}\n.file-manager__body-tree li ul {\n\tpadding: 0;\n}\n\n.li-text-content {\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\twhite-space: nowrap;\n\n\tpointer-events: none;\n\n\tuser-select: none;\n\tcursor: pointer;\n\tmargin: 0;\n\tpadding: 0 0 0 10px;\n\tz-index: 1;\n}\n\n.file-manager__body-tree .expand {\n\tz-index: 1;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tfont-size: 14px;\n}\n\n.li-text-content em {\n   font-size: 20px;\n   color: #FDDD34;\n   position: relative;\n}\n\n.li-text-content span {\n\tmargin-left: 2px;\n}\n\n\n.file-manager__body-tree li > div:hover {\n\tbackground-color: #e9ecef;\n\tborder-color: #e9ecef;\n\tcolor: #333;\n\tborder-radius: 4px;\n}\n\n.file-manager__body-tree li.active > div {\n\tbackground-color: #0d6efd;\n\tcolor: #fff;\n\ttext-overflow: ellipsis;\n\twhite-space: nowrap;\n\tfont-weight: 400;\n\topacity: 1;\n\twidth: 100%;\n\tborder-radius: 4px;\n}\n\n.file-manager__body-tree li.active > div > .li-text-content,\n.file-manager__body-tree li.active > div > .expand {\n\tcolor: #fff;\n}\n\n.file-manager__body-tree em.shared {\n\tposition: absolute;\n\tbottom: 0;\n\tleft: 2px;\n\tz-index: 1;\n\tcolor: #d2a055;\n\tfont-size: 14px;\n}\n\n.file-browser > .table-container {\n\toverflow-y: visible;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
